
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SupplierConfigFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SupplierConfig"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"concurrencyVersion"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"uuid"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"canReuseDeleted"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"alphaLength"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"numericLength"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"numericConfig"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isNumericPadded"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"genericSupplierSearchFields"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"nominalBusinessCategory"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"concurrencyVersion"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"nominalSupplierAccountSet"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"concurrencyVersion"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"code"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"vatBusinessCategory"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"concurrencyVersion"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"carriageVatProductCategory"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"uuid"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"concurrencyVersion"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"purchasePaymentTerm"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"concurrencyVersion"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"paymentDate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"paymentDays"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"paymentInterval"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"purchasePaymentMethod"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"concurrencyVersion"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"purchaseOrderMatchingType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"purchaseOrderMatchingVariance"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"updateStockValuationFromPurchaseInvoice"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"costPriceAdjustmentAccount"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"concurrencyVersion"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"accountNo"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"allowPostOverTolerance"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"autoAllocateSequence"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":954}};
    doc.loc.source = {"body":"fragment SupplierConfigFragment on SupplierConfig {\n  id\n  concurrencyVersion\n  uuid\n  canReuseDeleted\n  alphaLength\n  numericLength\n  numericConfig\n  isNumericPadded\n  genericSupplierSearchFields\n  nominalBusinessCategory {\n    id\n    concurrencyVersion\n    description\n  }\n  nominalSupplierAccountSet {\n    id\n    concurrencyVersion\n    code\n  }\n  vatBusinessCategory {\n    id\n    concurrencyVersion\n    description\n  }\n  carriageVatProductCategory {\n    id\n    uuid\n    concurrencyVersion\n    description\n  }\n  purchasePaymentTerm {\n    id\n    concurrencyVersion\n    description\n    paymentDate\n    paymentDays\n    paymentInterval\n  }\n  purchasePaymentMethod {\n    id\n    concurrencyVersion\n    description\n  }\n  purchaseOrderMatchingType\n  purchaseOrderMatchingVariance\n  updateStockValuationFromPurchaseInvoice\n  costPriceAdjustmentAccount {\n    id\n    concurrencyVersion\n    accountNo\n    name\n  }\n  allowPostOverTolerance\n  autoAllocateSequence\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["SupplierConfigFragment"] = oneQuery(doc, "SupplierConfigFragment");
        
